export default "__VITE_ASSET__534aa5c5__"